import {Component, input, OnChanges, OnDestroy, OnInit, output, SimpleChanges} from '@angular/core';
import {LangChangeEvent, TranslateModule, TranslateService} from "@ngx-translate/core";
import {Subscription} from "rxjs";
import {DjangoApiService} from "../../../../shared/services/django-api.service";
import {LanguageService} from "../../../../shared/services/language.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CardsBasicComponent} from "../../../../shared/components/cards/cards-basic/cards-basic.component";
import {MatChipListbox, MatChipOption} from "@angular/material/chips";

@Component({
  selector: 'app-benchmark-detail',
  standalone: true,
  imports: [
    CardsBasicComponent,
    MatChipListbox,
    MatChipOption,
    TranslateModule
  ],
  templateUrl: './benchmark-detail.component.html',
  styleUrl: './benchmark-detail.component.css'
})
export class BenchmarkDetailComponent implements OnInit, OnChanges, OnDestroy {
  productSlug!: any;
  benchmarkData!: any;
  selectedBenchmark: any = [];
  selectedBenchmarkChange = output<any>();
  benchmarkListInput = input<any>();

  currentLanguage!: string;
  langChangeSubscription: Subscription | null = null;

  private subscriptions: Subscription = new Subscription();


  constructor(
    private _languageService: LanguageService,
    private _translate: TranslateService,
    public _route: ActivatedRoute) {
  }


  ngOnInit() {
    this.setupLanguageSubscription();
    this.benchmarkData = this.benchmarkListInput();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['benchmarkListInput']) {
      this.benchmarkData = this.benchmarkListInput();
      this.resetSelectedPeriod();
    }
  }

  private setupLanguageSubscription(): void {
    this.currentLanguage = this._languageService.getLanguage();
    this.subscriptions.add(
      this.langChangeSubscription = this._translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.currentLanguage = event.lang;
      })
    );
  }

  selectBenchmark(benchmarkID: any) {
    const index = this.selectedBenchmark.indexOf(benchmarkID);
    if (index >= 0) {
      this.selectedBenchmark.splice(index, 1);
    } else {
      this.selectedBenchmark.push(benchmarkID);
    }
    this.selectedBenchmark = [...this.selectedBenchmark];

    this.selectedBenchmarkChange.emit(this.selectedBenchmark)
  }

  resetSelectedPeriod(){
    this.selectedBenchmark = [];
    this.selectedBenchmarkChange.emit(this.selectedBenchmark)
  }


  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

}
